var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '마이페이지'
    }
  }), _c('mypage-navigation'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "Attendance status",
      "tit": "출석 현황"
    }
  }), _c('v-data-table', _vm._b({
    staticClass: "v-data-table--default table--primary--large",
    attrs: {
      "hide-default-footer": "",
      "disable-filtering": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.program.name",
      fn: function fn(_ref) {
        var item = _ref.item,
          value = _ref.value;
        return [_c('router-link', {
          attrs: {
            "to": "/service/programs/".concat(item._program)
          }
        }, [_vm._v(_vm._s(value))])];
      }
    }, {
      key: "item.program.status",
      fn: function fn(_ref2) {
        var item = _ref2.item,
          value = _ref2.value;
        return [item.program.status == '접수종료' ? _c('v-chip', {
          attrs: {
            "color": "grey-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("접수종료")])]) : item.program.status == '모집마감' ? _c('v-chip', {
          attrs: {
            "color": "primary-dark",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "white--text"
        }, [_vm._v("모집마감")])]) : item.program.status == '진행종료' ? _c('v-chip', {
          attrs: {
            "color": "grey-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("진행종료")])]) : item.program.status == '접수중' ? _c('v-chip', {
          attrs: {
            "color": "primary-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v("접수중")])]) : item.program.status == '진행중' && item.isApproved ? _c('v-chip', {
          attrs: {
            "color": "green-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "green--text"
        }, [_vm._v("진행중")])]) : _c('v-chip', {
          attrs: {
            "color": _vm.stateColor(item),
            "label": ""
          }
        }, [_c('span', [_vm._v(_vm._s(value))])])];
      }
    }, {
      key: "item.state",
      fn: function fn(_ref3) {
        var _vm$PROGRAM_APPLICATI;
        var item = _ref3.item,
          value = _ref3.value;
        return [item.program.status == '진행종료' ? _c('v-chip', {
          attrs: {
            "color": "grey-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("진행종료")])]) : item.program.status == '진행중' && item.isApproved ? _c('v-chip', {
          attrs: {
            "color": "primary-light",
            "label": ""
          }
        }, [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v("진행중")])]) : _c('v-chip', {
          attrs: {
            "color": _vm.stateColor(item),
            "label": ""
          }
        }, [_c('span', [_vm._v(_vm._s((_vm$PROGRAM_APPLICATI = _vm.PROGRAM_APPLICATION_STATES[value]) === null || _vm$PROGRAM_APPLICATI === void 0 ? void 0 : _vm$PROGRAM_APPLICATI.text))])])];
      }
    }, {
      key: "item.cancel",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-btn', {
          staticClass: "v-btn--table",
          attrs: {
            "disabled": !_vm.isCancelable(item),
            "outlined": "",
            "small": "",
            "rounded": "",
            "elevation": "0",
            "color": "grey"
          },
          on: {
            "click": function click($event) {
              return _vm.cancel(item);
            }
          }
        }, [_c('span', {
          staticClass: "grey-dark--text"
        }, [_vm._v("신청취소")])])];
      }
    }, {
      key: "item.attend",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm.isAttendable(item) ? _c('v-btn', {
          staticClass: "v-btn--table",
          attrs: {
            "to": "/mypage/programs/".concat(item._program),
            "small": "",
            "rounded": "",
            "elevation": "0",
            "color": "orange"
          }
        }, [_c('span', {
          staticClass: "white--text"
        }, [_vm._v("출석확인")])]) : _vm._e()];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('pagination-component', {
          attrs: {
            "value": _vm.page,
            "count": _vm.pageCount
          },
          on: {
            "input": function input(page) {
              return _vm.$router.push({
                query: {
                  page: page
                }
              });
            }
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    items: _vm.items,
    headers: _vm.headers
  }, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }